import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Button, H3 } from '@blueprintjs/core';

import { ANALYTICS_URL, SIGNIN_URL, SIGNUP_URL } from '../constants';
import './Home.css';


const Home = (props) => {
  const {t}=props;

  return (
    <div className="Home__wrapper">
      <img
        src={process.env.PUBLIC_URL + '/assets/img/lexicoscope.png'}
        alt="Lexicoscope"
        className="largeLogo"
      />

      <section>
        <H3>{t('whatIsLexicoscope')}</H3>
        <p>{t('intro')}</p>
      </section>

      <section>
        <H3>{t('strength')}</H3>
        <ul>
          <li>{t('strength1')}</li>
          <li>{t('strength2')}</li>           
          <li>{t('strength3')}</li>           
          <li>{t('strength4')}</li>           
        </ul>
      </section>

      <section>
        <H3>{t('comingSoon')}</H3>
        <ul>
          <li>{t('todo1')}</li>
          <li>{t('todo2')}</li>           
          <li>{t('todo3')}</li> 
          <li>{t('notaBene')}</li>                  
        </ul>
      </section>

      <section className="Home__action">
        <div style={{textAlign:'center'}}>
          <Button className="Home__button bp3-intent-primary" icon="log-in" intent="success" onClick={() => props.history.push(SIGNIN_URL)} text={t('signIn')} />
          <Button className="Home__button bp3-intent-primary" icon="user" onClick={() => props.history.push(SIGNUP_URL)} text={t('signUp')} />
          <Button className="Home__button bp3-intent-primary" rightIcon="arrow-right"  onClick={() => props.history.push(ANALYTICS_URL)} text={t('testTheTool')} />
        </div>
      </section>  

    </div>
  );
};

export default withTranslation()(withRouter(Home));
